export const RECEIVE_ORDERS_REQUEST = 'RECEIVE_ORDERS_REQUEST';
export const SET_ORDERS_FETCHING = 'SET_ORDERS_FETCHING';
export const SET_ORDERS_LOADING = 'SET_ORDERS_LOADING';
export const TOGGLE_ORDERS_BOOLEAN = 'TOGGLE_ORDERS_BOOLEAN';
